import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/team/page.tsx");
